import React from 'react';

const AboutTemples = () => {
  const TempleData = [
    {
      "img": "./Images/Places/Temples/RamMandir/ramMandir.jpg",
      "name": "Ram Janmbhumi",
      "about": "Ram Janmbhumi, the birthplace of Lord Ram, holds immense significance in Hindu mythology. It is believed to be the place where Lord Ram, the seventh incarnation of Lord Vishnu, was born. Devotees from all over the world visit this sacred site to pay homage to Lord Ram and seek blessings for prosperity and happiness.",
      "wikiLink": "https://en.wikipedia.org/wiki/Ram_Janmabhoomi",
      "VID": "MCVrdWePWuQ",
      "lat": "26.795821661223048",
      "lng": "82.19443112566178",
    },
    {
      "img": "./Images/Places/Temples/Hanuman_Garhi/HanumanGarhiTemple.jpeg",
      "name": "Hanuman Garhi",
      "about": "Hanuman Garhi is a temple dedicated to Lord Hanuman, the epitome of devotion and strength in Hinduism. Situated in the heart of Ayodhya, this temple is known for its iconic statue of Lord Hanuman and its serene ambiance. Devotees flock here to seek Lord Hanuman's blessings for courage, protection, and fulfillment of desires.",
      "wikiLink": "https://en.wikipedia.org/wiki/Hanuman_Garhi",
      "VID": "X7U7HEEVnW4",
      "lat": "24.457300",
      "lng": "82.980470",
    },
    {
      "img": "./Images/Places/Temples/nageshwarNathTemple.jpg",
      "name": "NageswarNath Temple",
      "about": "NageswarNath Temple is a prominent Shiva temple in Ayodhya, dedicated to Lord Shiva, the supreme deity of destruction and regeneration in Hinduism. This ancient temple, adorned with intricate carvings and sculptures, is revered by devotees who seek Lord Shiva's blessings for spiritual upliftment and fulfillment of their desires.",
      "wikiLink": "https://en.wikipedia.org/wiki/Nageshwar_Nath_Temple",
      "VID": "gMkL4wkkfRk",
      "lat": "26.795821661223048",
      "lng": "82.19443112566178",
    },
    {
      "img": "./Images/Places/Temples/Kanak_Bhawan/kanakBhavan.jpg",
      "name": "Kanak Bhavan",
      "about": "Kanak Bhavan is a grand palace-like temple dedicated to Lord Ram and Goddess Sita. Legend has it that this opulent temple was gifted to Sita by her mother, Queen Kaikeyi, upon her marriage to Lord Ram. Devotees visit Kanak Bhavan to witness its architectural splendor and offer prayers for marital bliss, prosperity, and familial harmony.",
      "wikiLink": "https://en.wikipedia.org/wiki/Kanak_Bhavan",
      "VID": "0kSjT6V7Ufo",
      "lat": "26.798020",
      "lng": "82.199162",
    },
    {
      "img": "./Images/Places/Temples/tulsiUdyan.jpg",
      "name": "Tulsi Udyan",
      "about": "Tulsi Udyan is a serene garden dedicated to Goswami Tulsidas, located on the banks of the Sarayu River. This tranquil retreat offers a peaceful ambiance for meditation and reflection amidst lush greenery and floral landscapes. Devotees and nature enthusiasts frequent Tulsi Udyan to rejuvenate their minds and connect with nature's beauty.",
      "wikiLink": "https://en.wikipedia.org/wiki/Tulsi_Udyan",
      "VID": "sp1jFAHJaLs",
      "lat": "26.798020",
      "lng": "82.199162",
    },
    {
      "img": "./Images/Places/Temples/maniparvat.jpg",
      "name": "Mani Parvat",
      "about": "Mani Parvat is a sacred hill in Ayodhya, revered for its religious significance and natural beauty. It is believed to be the spot where Lord Brahma performed the sacred yajna (fire sacrifice) during the creation of the universe. Pilgrims trek to the summit of Mani Parvat to offer prayers and witness breathtaking panoramic views of Ayodhya.",
      "wikiLink": "https://en.wikipedia.org/wiki/Mani_Parvat",
      "VID": "q1oEgLDjOCU",
      "lat": "26.798020",
      "lng": "82.199162",
    },
    {
      "img": "./Images/Places/Temples/rajaRamMandir.jpg",
      "name": "RajaRam Mandir",
      "about": "RajaRam Mandir is a magnificent temple dedicated to Lord Ram, showcasing exquisite architecture and intricate sculptures depicting scenes from the epic Ramayana. Devotees flock to this temple to participate in elaborate rituals and ceremonies honoring Lord Ram's divine glory and righteousness. The spiritual aura of RajaRam Mandir attracts seekers of truth and enlightenment.",
      "wikiLink": "https://en.wikipedia.org/wiki/Raja_Ram_Temple,_Orchha",
      "VID": "",
      "lat": "26.798020",
      "lng": "82.199162",
    }
  ];

  return TempleData;
}

export default AboutTemples;
